import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function AboutUs() {
  const { t } = useTranslation();
  const [isRecommendedLoaded, setIsRecommendedLoaded] = useState(false);
  const [isCloudLoaded, setIsCloudLoaded] = useState(false);
  const [isCloudFadeInComplete, setIsCloudFadeInComplete] = useState(false);
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'zh');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 833);

  // 检测移动端
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 833);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 预加载推荐版背景图和云朵图，加载完成后淡入显示
  useEffect(() => {
    // 预加载推荐版背景图片
    const recommendedImage = new Image();
    
    // 先设置onload，再设置src，这样如果图片已在缓存中，onload会立即触发
    recommendedImage.onload = () => {
      setIsRecommendedLoaded(true);
    };
    recommendedImage.onerror = () => {
      // 如果推荐版加载失败，保持使用压缩版
      console.warn('推荐版背景图加载失败，继续使用压缩版');
    };
    
    // 设置src触发加载（如果已在缓存中，onload会立即触发）
    recommendedImage.src = '/image/关于我们背景.jpg';
    
    // 如果图片已经在缓存中，立即标记为已加载
    if (recommendedImage.complete) {
      setIsRecommendedLoaded(true);
    }
    
    // 预加载云朵图原版
    const cloudImage = new Image();
    cloudImage.onload = () => {
      setIsCloudLoaded(true);
      // 等待淡入动画完成（0.6秒）后，标记淡入完成，开始淡出压缩版
      setTimeout(() => {
        setIsCloudFadeInComplete(true);
      }, 600);
    };
    cloudImage.onerror = () => {
      // 如果原版加载失败，保持使用压缩版
      console.warn('云朵图原版加载失败，继续使用压缩版');
    };
    cloudImage.src = '/image/首页顶部云朵.png';
    
    // 如果图片已经在缓存中，立即标记为已加载
    if (cloudImage.complete) {
      setIsCloudLoaded(true);
      // 等待淡入动画完成（0.6秒）后，标记淡入完成，开始淡出压缩版
      setTimeout(() => {
        setIsCloudFadeInComplete(true);
      }, 600);
    }
    
    // 预加载标题图片
    const titleImage = new Image();
    titleImage.src = '/image/关于我们2122.png';
  }, []);

  // 监听语言变化
  useEffect(() => {
    setCurrentLanguage(i18n.language || 'zh');
  }, [i18n.language]);

  return (
    <div className="aboutus-container">
      <div 
        className="aboutus-hero-background"
        style={{ 
          position: 'relative'
        }}
      >
        {/* 压缩版背景层 - 始终显示，作为底层 */}
        <div 
          className="aboutus-hero-bg-layer aboutus-hero-bg-compressed"
          style={{ 
            backgroundImage: `url(${isMobile ? '/image/移动端关于我们.png' : '/image/关于我们背景.jpg'})`,
            ...(isMobile && {
              backgroundSize: 'contain',
              backgroundPosition: 'center top'
            })
          }}
        />
        {/* 推荐版背景层 - 始终存在，加载完成后淡入显示，覆盖压缩版 */}
        <div 
          className="aboutus-hero-bg-layer aboutus-hero-bg-recommended"
          style={{ 
            backgroundImage: `url(${isMobile ? '/image/移动端关于我们.png' : '/image/关于我们背景.jpg'})`,
            opacity: isMobile ? 1 : (isRecommendedLoaded ? 1 : 0),
            transition: isMobile ? 'none' : (isRecommendedLoaded ? 'opacity 0.6s ease-in-out' : 'none'),
            ...(isMobile && {
              backgroundSize: 'contain',
              backgroundPosition: 'center top'
            })
          }}
        />
        <div className="aboutus-hero-text-container">
          <div 
            className="aboutus-section-title" 
            style={{ 
              backgroundImage: 'url(/image/关于我们2122.png)'
            }}
          >
            {t('aboutus.hero.title')}
          </div>
          <div className="aboutus-section-content">
            <p>{t('aboutus.hero.description')}</p>
          </div>
        </div>
        <div className="aboutus-container-image">
          <div 
            className="aboutus-cloud-layer aboutus-cloud-compressed"
            style={{
              backgroundImage: 'url(/image/首页顶部云朵-已压缩.png)',
              opacity: isCloudFadeInComplete ? 0 : 1,
              transition: isCloudFadeInComplete ? 'opacity 0.6s ease-in-out' : 'none',
              transform: 'scaleX(-1)'
            }}
          />
          <div 
            className="aboutus-cloud-layer aboutus-cloud-original"
            style={{
              backgroundImage: 'url(/image/首页顶部云朵.png)',
              opacity: isCloudLoaded ? 1 : 0,
              transition: isCloudLoaded ? 'opacity 0.6s ease-in-out' : 'none',
              transform: 'scaleX(-1)'
            }}
          />
        </div>
      </div>
        <div className="aboutus-section-container">
          {/* 创生基金部分 */}
          
          <div className="foundation-card">
            <div className="foundation-card-content">
              <div className="foundation-card-text">
                <div className="aboutus-section-header">
                  <div className="aboutus-section-title2">{t('aboutus.foundation.title')}
                    <span className="aboutus-section-title2-dot"></span>
                  </div>
                </div>
                <p>{t('aboutus.foundation.description1')}</p>
                { currentLanguage === 'en' ? (<>
                </>) : (<>
                  <p>{t('aboutus.foundation.description2')}</p>
                  <p>{t('aboutus.foundation.description3')}</p>
                </>) }
              </div>
              <div className="foundation-card-image-wrapper">
                <div className="foundation-card-image" style={{ backgroundImage: 'url(/image/关于我们简介.jpg)' }}></div>
              </div>
            </div>
          </div>

          {/* 创始人部分 */}
          <div className="aboutus-section-header aboutus-founder-section-header">
            <div className="aboutus-section-title2">{t('aboutus.founder.sectionTitle')}
              <span className="aboutus-section-title2-dot"></span>
            </div>
          </div>
          <div className="founder-card">
            <div className="founder-card-content">
              <div className="founder-card-left">
                <div className="founder-avatar-wrapper">
                  <div className="founder-image" style={{ backgroundImage: 'url(/image/老板照片.png)' }}></div>
                </div>
                <div className="founder-qrcode-wrapper">
                  <div className="founder-qrcode-card">
                    <img src="/image/二维码.png" alt="QR Code" className="founder-qrcode" loading="lazy" />
                    <div className="founder-qrcode-title">{t('aboutus.qrcode.title')}</div>
                    <div className="founder-qrcode-subtitle">{t('aboutus.qrcode.subtitle')}</div>
                  </div>
                </div>
              </div>
              <div className="founder-card-right">
                { currentLanguage === 'en' ? (<>
                  <div className="founder-name" style={{ fontFamily: getLanguageFontWithFallback('en'), marginBottom: '12px' }}>{t('aboutus.founder.nameEn')}</div>
                </>) : (<>
                  <div className="founder-name" style={{ fontFamily: "Ctrip Font" }}>{t('aboutus.founder.name')}</div>
                  <div className="founder-name-en">{t('aboutus.founder.nameEn')}</div>
                </>) }
                
                <div className="founder-titles">
                  <p>{t('aboutus.founder.title1')}</p>
                  <p>{t('aboutus.founder.title2')}</p>
                  <p>{t('aboutus.founder.title3')}</p>
                  <p>{t('aboutus.founder.title4')}</p>
                </div>
                <div className="founder-bio">
                  <p>{t('aboutus.founder.bio.paragraph1')}</p>
                  <p>{t('aboutus.founder.bio.paragraph2')}</p>
                  <p>{t('aboutus.founder.bio.paragraph3')}</p>
                  <p>{t('aboutus.founder.bio.paragraph4')}</p>
                  <p>{t('aboutus.founder.bio.paragraph5')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default AboutUs;

